module.exports = __webpack_public_path__ + "img/camera-retro.790bea26.svg";